// extracted by mini-css-extract-plugin
module.exports = {"content":"RestoreExportFooter_content__2xr5l","buttons":"RestoreExportFooter_buttons__1VQe0"};